module.exports = __webpack_public_path__ + "media/images/icons/illustration/money-1558c32dc3f6c0f72b361cb3ef564f7c.svg";